import { domReady } from '../modules/utils.js';

class PageHeroEditorial2Track extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.#duplicateGroup();
  }

  #duplicateGroup() {
    const track = this.querySelector('.pageheroedit-slider-track');
    const group = track?.querySelector('.pageheroedit-slider-group');

    if (!track || !group) return;

    const clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  }
}

customElements.define('pageheroedit-slider-track', PageHeroEditorial2Track);
